export const RATEHAWK_API_LIMIT_VALUES = {
    max_days: 30,
    pax_adult: 6,
    pax_child: 4,
    pax_infant: 4,
  }

// Default hotel+flight window around a selected event date (event date ± N days)
export const EVENT_PACKAGE_DATE_OFFSET_DAYS = 3;

export enum COORDS_TYPE {
  VENUE = 'venue',
  CITY = 'city',
}

export const SIDE_FILTER_KEYS = new Set([
  'boardBasis',
  'price',
  'directFlight',
  'stops',
  'airline',
  'from_date_hours',
  'from_date_landing_hours',
  'include_baggage',
  'return_date_landing_hours',
  'return_date_hours',
  'include_trolly',
  'sortBy',
  "auto_approve",
  "location",
  'include_transfer',
  'include_baggage',
  "feature",
  'hotel_stars',
  'hotel',
  'is_special',
  'taxonomy',
  'attraction_stars',
  'hotel_type',
  'freeCancellation',
  // // TAZOS comment:
  // add 'destinationCity' to SIDE_FILTER_KEYS to fix bug for hotel search, because now when we refreshing search result page destination selector is not initializing properly
  // 'destinationCity' // TAZO included in the side filters, for a fix but it should not be here !!
]);